/* EcoFilter Ireland - water softener page 2026
   Eircode hardness lookup (same zone table as the homepage and /pages/water-hardness-checker),
   Ireland hardness chart, sizing helper, cost estimate and the mobile sticky bar.
   No network calls. Nothing is stored.
   Oct 2026: towns with landing pages added (est:1 = regional figure, not a supply-zone reading). */
(function () {
  var root = document.querySelector('.sw2');
  if (!root) return;

  /* Oct 2026: A81 is Carrickmacross, not Trim (Trim is C15). The section files still print the old
     A81 "Trim" sample button and chart label, so correct them here. */
  root.querySelectorAll('button[data-eircode="A81"]').forEach(function (b) {
    if (b.textContent.trim() === 'Trim') b.setAttribute('data-eircode', 'C15');
  });
  var rankFix = document.getElementById('sw-rank');
  if (rankFix && document.createTreeWalker) {
    var tw = document.createTreeWalker(rankFix, 4), tn;
    while ((tn = tw.nextNode())) { if (tn.nodeValue.indexOf('Co. Meath, A81') > -1) tn.nodeValue = tn.nodeValue.replace('Co. Meath, A81', 'Co. Meath, C15'); }
  }

  /* ---------- data ---------- */
  var ZONES = {
    "C15":{town:"Navan / Trim, Co. Meath",mgl:355},"A81":{town:"Carrickmacross, Co. Monaghan (borehole supply)",mgl:250,est:1},"A82":{town:"Kells, Co. Meath (Cavan towns on A82 are softer)",mgl:355},
    "H18":{town:"Monaghan town (borehole supply)",mgl:250,est:1},"A75":{town:"Castleblayney / Ballybay (Lough Egish supply)",mgl:100,est:1},"H12":{town:"Cavan town (Lough Acanon supply)",mgl:50,est:1},
    "A84":{town:"Ashbourne, Co. Meath",mgl:355},"A85":{town:"Dunshaughlin area, Co. Meath",mgl:355},"A86":{town:"Dunboyne, Co. Meath",mgl:355},
    "K32":{town:"Balbriggan (Bog of the Ring supply)",mgl:336},"K34":{town:"Skerries (Bog of the Ring supply)",mgl:336},"K56":{town:"Rush / Lusk (Bog of the Ring supply)",mgl:336},
    "K67":{town:"Swords (Leixlip supply)",mgl:200},"K36":{town:"Malahide (Leixlip supply)",mgl:200},"K78":{town:"Lucan (Leixlip supply)",mgl:200},"D15":{town:"Blanchardstown, Dublin 15 (Leixlip supply)",mgl:200},
    "D11":{town:"Finglas / North Dublin (Leixlip supply)",mgl:200},"W23":{town:"Maynooth / Celbridge / Leixlip (Leixlip supply)",mgl:200},
    "D02":{town:"Dublin 2 (Ballymore Eustace supply)",mgl:50},"D04":{town:"Dublin 4 (Ballymore Eustace supply)",mgl:50},"D06":{town:"Dublin 6 (Ballymore Eustace supply)",mgl:50},
    "D6W":{town:"Dublin 6W (Ballymore Eustace supply)",mgl:50},"D08":{town:"Dublin 8 (Ballymore Eustace supply)",mgl:50},"D14":{town:"Dublin 14 (Ballymore Eustace supply)",mgl:50},
    "D16":{town:"Dublin 16 (Ballymore Eustace supply)",mgl:50},"D18":{town:"Dublin 18 (Ballymore Eustace supply)",mgl:50},"D24":{town:"Tallaght, Dublin 24 (Ballymore Eustace supply)",mgl:50},
    "A94":{town:"Blackrock, Co. Dublin",mgl:50},"A96":{town:"Dún Laoghaire area",mgl:50},"A98":{town:"Bray, Co. Wicklow (Vartry supply)",mgl:50},
    "A63":{town:"Greystones, Co. Wicklow (Vartry supply)",mgl:50},"A67":{town:"Wicklow Town (Vartry supply)",mgl:50},
    "D10":{town:"Ballyfermot, Dublin (blended supply)",mgl:155},"D12":{town:"Crumlin, Dublin (blended supply)",mgl:155},"D20":{town:"Palmerstown, Dublin (blended supply)",mgl:155},"D22":{town:"Clondalkin, Dublin (blended supply)",mgl:155},
    "W91":{town:"Naas, Co. Kildare",mgl:325},"W12":{town:"Newbridge, Co. Kildare",mgl:325},"R14":{town:"Athy, Co. Kildare",mgl:325},
    "A92":{town:"Drogheda, Co. Louth",mgl:310},"A91":{town:"Dundalk, Co. Louth",mgl:310},"R32":{town:"Portlaoise, Co. Laois",mgl:300},"R35":{town:"Tullamore, Co. Offaly",mgl:300},
    "R93":{town:"Carlow town (Barrow supply)",mgl:300,est:1},"R95":{town:"Kilkenny city (Nore and limestone)",mgl:300,est:1},"N37":{town:"Athlone, Co. Westmeath (Lough Ree supply)",mgl:280,est:1},"N91":{town:"Mullingar, Co. Westmeath (Lough Owel supply)",mgl:280,est:1},
    "Y21":{town:"Wexford area",mgl:240},"Y35":{town:"Wexford town",mgl:240},"Y25":{town:"Gorey, Co. Wexford",mgl:240,est:1},
    "E41":{town:"Thurles, Co. Tipperary",mgl:235},"E91":{town:"Clonmel, Co. Tipperary (mixed supply)",mgl:235,est:1},"E45":{town:"Nenagh, Co. Tipperary",mgl:235,est:1},
    "X91":{town:"Waterford City",mgl:230},"X35":{town:"Dungarvan, Co. Waterford",mgl:230,est:1},
    "T12":{town:"Cork City",mgl:200},"T23":{town:"Cork City",mgl:200},"P51":{town:"Mallow, Co. Cork (Blackwater valley)",mgl:200,est:1},
    "V94":{town:"Limerick City",mgl:250},"V95":{town:"Ennis, Co. Clare (limestone springs)",mgl:300,est:1},"V14":{town:"Shannon, Co. Clare",mgl:250,est:1},
    "H91":{town:"Galway City (Lough Corrib supply)",mgl:135},"H54":{town:"Tuam, Co. Galway (limestone groundwater)",mgl:300,est:1},"H53":{town:"Ballinasloe, Co. Galway",mgl:300,est:1},"H62":{town:"Loughrea, Co. Galway",mgl:300,est:1},
    "V93":{town:"Killarney, Co. Kerry",mgl:130},"F91":{town:"Sligo Town (Lough Gill supply)",mgl:110},"F92":{town:"Letterkenny, Co. Donegal",mgl:75}
  };
  var PREFIX = {
    "D":{region:"North Dublin (Leixlip supply)",mgl:200},"A":{region:"North Leinster",mgl:320},"K":{region:"North Co. Dublin",mgl:200},"W":{region:"Co. Kildare",mgl:325},
    "C":{region:"Co. Meath",mgl:355},"R":{region:"Midlands (Laois / Offaly / Carlow / Kilkenny)",mgl:300},"N":{region:"Midlands (Westmeath / Longford)",mgl:280},
    "Y":{region:"Co. Wexford",mgl:240},"X":{region:"Co. Waterford",mgl:230},"E":{region:"Co. Tipperary",mgl:235},"T":{region:"Cork region",mgl:200},"P":{region:"Co. Cork",mgl:200},
    "V":{region:"Mid-West (Limerick / Clare)",mgl:250},"H":{region:"West / Border region",mgl:150},"F":{region:"North-West",mgl:100}
  };

  var state = { mgl: null, people: 4 };

  function band(m) {
    if (m < 100) return { label: "Soft", color: "#2f9e6e" };
    if (m < 200) return { label: "Moderately hard", color: "#d9a013" };
    if (m < 300) return { label: "Hard", color: "#e07a1f" };
    return { label: "Very hard", color: "#d2402e" };
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function eur(n) { return '€' + Math.round(n).toLocaleString('en-IE'); }
  function routingKey(raw) {
    var v = String(raw || '').toUpperCase().replace(/\s+/g, '');
    if (v.length < 3) return null;
    var k = v.slice(0, 3);
    return /^[A-Z][0-9A-Z]{2}$/.test(k) ? k : null;
  }

  /* ---------- Eircode checker ---------- */
  var form = document.getElementById('sw-hardness-form');
  var input = document.getElementById('sw-eircode');
  var panel = document.getElementById('sw-hardness-result');
  var err = document.getElementById('sw-hardness-err');
  var fullReport = form ? form.getAttribute('action') : '/pages/water-hardness-checker';

  function adviceFor(m) {
    if (m >= 300) return { copy: "Scale forms in your cylinder, boiler and appliances every day at this level. A whole-house softener is the right tool here, and it earns its keep quickly.", cta: "Find my size", link: "#range" };
    if (m >= 200) return { copy: "Hard enough to shorten the life of a boiler, shower and washing machine. A softener stops that at the front door.", cta: "Find my size", link: "#range" };
    if (m >= 100) return { copy: "Middle band. Scale builds slowly rather than fast. A compact softener still makes sense if you're seeing it on taps and screens; if taste is the bigger complaint, start with a drinking water filter.", cta: "See the range", link: "#range" };
    return { copy: "Limescale isn't your problem at this level and a softener wouldn't earn its money. If taste or chlorine is the issue, an under-sink drinking water system is the right buy.", cta: "Drinking water systems", link: "/pages/ecosoft-standard-pro" };
  }

  function renderResult(key, zone, estimate) {
    var b = band(zone.mgl), a = adviceFor(zone.mgl);
    var pct = Math.min(zone.mgl / 400, 1) * 100;
    panel.innerHTML =
      '<div class="res-head"><span class="res-zone">' + esc(zone.town) + '</span><span class="res-src">' + (estimate ? 'Regional estimate' : 'Uisce Éireann supply zone') + '</span></div>' +
      '<div class="res-reading"><b>' + zone.mgl + '</b><span>mg/L CaCO₃</span><em class="res-chip" style="background:' + b.color + '">' + b.label + '</em></div>' +
      '<div class="res-strip" aria-hidden="true"><div class="res-bar"><i></i><i></i><i></i><i></i></div><span class="res-marker" id="sw-res-marker" style="left:0"></span><div class="res-labels"><span>Soft</span><span>Moderately hard</span><span>Hard</span><span>Very hard</span></div></div>' +
      '<p class="res-copy">' + esc(a.copy) + '</p>' +
      '<div class="res-actions"><a class="btn btn--green" href="' + a.link + '">' + esc(a.cta) + '</a><a class="link" href="' + esc(fullReport + '?eircode=' + encodeURIComponent(key)) + '">Full report</a><button type="button" class="link" id="sw-res-again">Check another</button></div>';
    err.hidden = true; form.hidden = true; panel.hidden = false;
    var samples = document.getElementById('sw-samples'); if (samples) samples.hidden = true;
    requestAnimationFrame(function () { requestAnimationFrame(function () {
      var mk = document.getElementById('sw-res-marker'); if (mk) mk.style.left = 'calc(' + pct + '% - 2px)';
    }); });
    document.getElementById('sw-res-again').addEventListener('click', function () {
      panel.hidden = true; form.hidden = false; if (samples) samples.hidden = false; input.value = ''; input.focus();
    });
    state.mgl = zone.mgl;
    updateSizer();
    updateEstimate();
  }

  function lookup(raw) {
    err.hidden = true;
    var k = routingKey(raw);
    if (!k) { err.hidden = false; input.focus(); return; }
    var z = ZONES[k];
    if (z) { renderResult(k, z, !!z.est); return; }
    var p = PREFIX[k.charAt(0)];
    if (p) { renderResult(k, { town: p.region, mgl: p.mgl }, true); return; }
    err.hidden = false; input.focus();
  }

  if (form) {
    form.addEventListener('submit', function (e) { e.preventDefault(); lookup(input.value); });
    var samples = document.getElementById('sw-samples');
    if (samples) samples.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-eircode]'); if (!b) return;
      input.value = b.getAttribute('data-eircode'); lookup(input.value);
    });
    /* arrive with ?eircode= from another page */
    try {
      var q = new URLSearchParams(location.search).get('eircode');
      if (q && routingKey(q)) { input.value = q; lookup(q); }
    } catch (e) {}
  }

  /* ---------- Ireland chart: fill bars once visible ---------- */
  var rank = document.getElementById('sw-rank');
  if (rank) {
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) { rank.classList.add('on'); io.disconnect(); } });
      }, { threshold: .25 });
      io.observe(rank);
    } else { rank.classList.add('on'); }
  }

  /* ---------- household size (shared by sizer and estimate) ---------- */
  var chipGroups = root.querySelectorAll('[data-people-group]');
  function setPeople(n) {
    state.people = n;
    chipGroups.forEach(function (g) {
      g.querySelectorAll('.chip').forEach(function (c) { c.setAttribute('aria-pressed', String(Number(c.getAttribute('data-people')) === n)); });
    });
    updateSizer();
    updateEstimate();
  }
  chipGroups.forEach(function (g) {
    g.addEventListener('click', function (e) {
      var c = e.target.closest('.chip[data-people]'); if (!c) return;
      setPeople(Number(c.getAttribute('data-people')));
    });
  });

  /* ---------- sizer ---------- */
  var prods = root.querySelectorAll('.prod[data-model]');
  var sizerOut = document.getElementById('sw-sizer-out');
  function pickModel() {
    var p = state.people, m = state.mgl;
    var model = p <= 3 ? 'mini' : (p <= 5 ? 'midi' : 'maxi');
    var why = p <= 3 ? 'Up to three people' : (p <= 5 ? 'Four or five people' : 'Six or more people');
    if (m !== null && m >= 300 && p === 5) {
      model = 'maxi';
      why = 'Five people on very hard water, so we go up a size';
    } else if (m !== null && m >= 300) {
      why += ' on very hard water';
    }
    return { model: model, why: why };
  }
  function updateSizer() {
    if (!prods.length) return;
    var pick = pickModel();
    prods.forEach(function (el) { el.classList.toggle('rec', el.getAttribute('data-model') === pick.model); });
    if (sizerOut) {
      var el = root.querySelector('.prod[data-model="' + pick.model + '"]');
      var name = el ? el.getAttribute('data-name') : pick.model;
      sizerOut.innerHTML = '<span>' + esc(pick.why) + '</span><b>' + esc(name) + '</b>';
    }
  }

  /* ---------- cost estimate ---------- */
  var estTotal = document.getElementById('sw-est-total');
  var estRows = document.getElementById('sw-est-rows');
  var estPay = document.getElementById('sw-est-pay');
  function updateEstimate() {
    if (!estTotal) return;
    var p = state.people;
    var m = state.mgl === null ? 300 : state.mgl;          /* assume hard until they check */
    var f = Math.max(.35, Math.min(1.25, m / 300));         /* scale the estimate with hardness */
    var energy = 55 * p * f;                                  /* scale on immersion / cylinder / boiler elements */
    var soap = 30 * p * f;                                    /* detergent, shampoo, soap going further */
    var clean = (40 + 10 * p) * f;                            /* descaler, limescale sprays, kettle descales */
    var wear = (90 + 15 * p) * f;                             /* earlier replacement of kettles, showers, washing machine, dishwasher */
    var salt = 40 + 8 * p;                                    /* tablet salt */
    var gross = energy + soap + clean + wear;
    var net = gross - salt;
    var pick = pickModel();
    var el = root.querySelector('.prod[data-model="' + pick.model + '"]');
    var price = el ? Number(el.getAttribute('data-fitted')) : 0;
    estTotal.innerHTML = '<b>' + eur(net) + '</b><span>a year, estimated, after salt</span>';
    estRows.innerHTML =
      '<li><span>Extra energy heating scaled elements<small>Immersion, cylinder coil and combi heat exchanger</small></span><b>' + eur(energy) + '</b></li>' +
      '<li><span>Detergent, shampoo and soap<small>Soft water lathers with far less</small></span><b>' + eur(soap) + '</b></li>' +
      '<li><span>Descalers and limescale cleaners<small>Kettle descales, shower screen sprays</small></span><b>' + eur(clean) + '</b></li>' +
      '<li><span>Appliances replaced early<small>Kettles, showers, washing machine, dishwasher, spread over their life</small></span><b>' + eur(wear) + '</b></li>' +
      '<li><span>Less: tablet salt<small>Roughly a 25 kg bag every 4 to 8 weeks</small></span><b>&minus;' + eur(salt) + '</b></li>' +
      '<li class="est-net"><span>Net saving per year</span><b>' + eur(net) + '</b></li>';
    if (estPay && price) {
      var months = Math.round(price / net * 12);
      var yrs = Math.floor(months / 12), mo = months % 12;
      var txt = yrs ? (yrs + (yrs === 1 ? ' year' : ' years') + (mo ? ' ' + mo + ' months' : '')) : (months + ' months');
      estPay.innerHTML = 'At ' + eur(price) + ' fitted, the ' + esc(el.getAttribute('data-name')) + ' pays for itself in about <b>' + txt + '</b>.';
    }
  }

  setPeople(state.people);

  /* ---------- sticky bar on mobile ---------- */
  var stick = document.getElementById('sw-stick');
  var hero = root.querySelector('.hero');
  if (stick && hero && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { stick.classList.toggle('on', !en.isIntersecting); });
    }, { threshold: 0 }).observe(hero);
  }
})();
